import { render, staticRenderFns } from "./integrationSettingsForm.vue?vue&type=template&id=27c5eccd&scoped=true&"
import script from "./integrationSettingsForm.vue?vue&type=script&lang=js&"
export * from "./integrationSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./integrationSettingsForm.vue?vue&type=style&index=0&id=27c5eccd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c5eccd",
  null
  
)

export default component.exports